exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table[data-v-26772fb0]{border-collapse:collapse\n}\n.isOrderItem td[data-v-26772fb0]{padding-top:8px;padding-bottom:8px\n}\n.isGoodItem td[data-v-26772fb0]{min-height:60px\n}\n", ""]);

// exports
